import script from "./DocxViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocxViewer.vue?vue&type=script&setup=true&lang=ts"

import "./DocxViewer.vue?vue&type=style&index=0&id=688d01f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688d01f1"]])

export default __exports__